import { dryrun, message, createDataItemSigner, result } from "@permaweb/aoconnect";
import { PermissionType } from 'arconnect';
import { send } from "process";

export const WAR = "LneuOxjmOpTHZyxWlSIWttL8QX_7FNgkjK5Ybs4E2TA";
const DUMDUMZ = "JAHF1fo4MECRZZFKGcT0B6XM94Lqe-3FtB4Ht_kTEK0"

const permissions: PermissionType[] = [
    'ACCESS_ADDRESS',
    'SIGNATURE',
    'SIGN_TRANSACTION',
    'DISPATCH'
];

interface Tag {
    name: string;
    value: string;
}

export const SendProcessMessage = async (processID: string, action: string, data: string ): Promise<string> => { 
    
    // console.log("processID: " +processID);
    
    try {
        const getResult = await message({
            process: processID,
            tags: [
                { name: 'Action', value: action },
            ],
            data: data,
            signer: createDataItemSigner(window.arweaveWallet),
        });
        const { Messages, Error } = await result({
            message: getResult,
            process: processID,
        });
        if (Error) {
            console.log("Error:" + Error);
            return "Error:" + Error;
        }
        if (!Messages || Messages.length === 0) {
            console.log("No messages were returned from ao. Please try later.");
            return "No messages were returned from ao. Please try later."; 
        }
        
        console.log('Success: ', Messages[0]);
        return Messages[0].Data; // Note: this is only sending the Data of the msg
    } catch (error) {
        console.log('There was an error adding project: ' + error);
        return "Error";
    }
};


export const GetProcessInfo = async (processID: string ): Promise<string> => { 
    console.log("processID: " +processID);
    
    try {
        
        const getResult = await message({
            process: processID,
            tags: [
                { name: 'Action', value: 'Info' },
            ],
            signer: createDataItemSigner(window.arweaveWallet),
        });
        const { Messages, Error } = await result({
            message: getResult,
            process: processID,
        });
        if (Error) {
            console.log("Error:" + Error);
            return "Error:" + Error;
        }
        if (!Messages || Messages.length === 0) {
            console.log("No messages were returned from ao. Please try later.");
            return "No messages were returned from ao. Please try later."; 
        }
        
        console.log('Success: ' + Messages[0].Data);
        return Messages[0].Data;
    } catch (error) {
        console.log('There was an error adding project: ' + error);
        return "Error";
    }
   

};

export const GetAllCollection = async (): Promise<string> => {
    try {
        const getResult = await message({
            process: DUMDUMZ,
            tags: [
                { name: 'Action', value: 'Info' },
            ],
            signer: createDataItemSigner(window.arweaveWallet),
        });
        const { Messages, Error } = await result({
            message: getResult,
            process: DUMDUMZ,
        });
        if (Error) {
            console.log("Error:" + Error);
            return "Error:" + Error;
        }
        if (!Messages || Messages.length === 0) {
            console.log("No messages were returned from ao. Please try later.");
            return "No messages were returned from ao. Please try later."; 
        }
        // console.log('Success: ' + Messages[0].Data);
        return Messages[0].Data;
    } catch (error) {
        console.log('There was an error adding project: ' + error);
        return "Error";
    }
};


export const CheckHashInCollections = async (hash: string) => {
    console.log("Checking hash in collections:", hash);
    try {
      const response = await fetch("https://arweave.net/3f1YmLUpveTfDT11S1ilh_oquzzn9dWgqacY75OgQW4");
  
      // Check if the response is successful
      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
        return false;
      }
  
      // Log headers to inspect content-type
      console.log("Response Headers:", response.headers);
  
      // Check if the response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('Received non-JSON response:', contentType);
        return false;
      }
  
      const data = await response.json();
      console.log("Data: ", data , "Length: ", data["Assets"].length);
  
      // Logic for checking collections and assets can go here
      let found = false;

      for (let i = 0; i < data["Assets"].length; i++) {
        if (data["Assets"][i] === hash) {
          console.log("Hash found in collection:", data["Assets"][i]);
          found = true;
          break;
        }
      }
      
      // Your logic to search through data goes here
        // Check if Collections exists and is an array
    // if (!data.Collections || !Array.isArray(data.Collections)) {
    //     console.error("Collections is undefined or not an array:", data.Collections);
    //     return false;
    //     }

    // const collections = data.Collections;

    // collections.forEach((collection: { Id: string; Assets: { Hash: string }[] }) => {
    //   console.log("Found Collection ID:", collection.Id);
      
    //   // Check if the hash is found in the "Assets" array
    //   if (collection.Assets && collection.Assets.some(asset => asset.Hash === hash)) {
    //     console.log("Hash found in Assets:", hash);
    //     found = true;
    //   }
    // });
  
      return found;
    } catch (error) {
      console.error('Error fetching JSON file:', error);
      return false;
    }
  };  

  export const BorrowAvatar = async () => {
    
    try {
      const response = await fetch("https://arweave.net/tlPFryAFeIycZ1_b20zvTIW6Udb0SRV1Pzw1C9P9QMs");
      const data = await response.json();
    
      const ids = data.ids; 
      console.log("IDs: ", ids);
    
      // Select a random ID from the array
      const randomId = ids[Math.floor(Math.random() * ids.length)].id;
      
      console.log("Random ID:", randomId);
  
      return randomId;
    } catch (error) {
      console.error('Error fetching JSON file:', error);
      return null;
    }
  };

  export const CheckForBackCollection = async (hash: string) => {
    console.log("Checking hash in collections:", hash);
    try {
      const response = await fetch("https://arweave.net/3f1YmLUpveTfDT11S1ilh_oquzzn9dWgqacY75OgQW4");
  
      // Check if the response is successful
      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
        return false;
      }
  
      // Log headers to inspect content-type
      console.log("Response Headers:", response.headers);
  
      // Check if the response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('Received non-JSON response:', contentType);
        return false;
      }
  
      const data = await response.json();
      console.log("Data: ", data , "Length: ", data["Assets"].length);
  
      // Logic for checking collections and assets can go here
      let found = false;

      for (let i = 0; i < data["Assets"].length; i++) {
        if (data["Assets"][i] === hash) {
          console.log("Hash found in collection:", data["Assets"][i]);
          found = true;
          break;
        }
      }
      
      // Your logic to search through data goes here
        // Check if Collections exists and is an array
    // if (!data.Collections || !Array.isArray(data.Collections)) {
    //     console.error("Collections is undefined or not an array:", data.Collections);
    //     return false;
    //     }

    // const collections = data.Collections;

    // collections.forEach((collection: { Id: string; Assets: { Hash: string }[] }) => {
    //   console.log("Found Collection ID:", collection.Id);
      
    //   // Check if the hash is found in the "Assets" array
    //   if (collection.Assets && collection.Assets.some(asset => asset.Hash === hash)) {
    //     console.log("Hash found in Assets:", hash);
    //     found = true;
    //   }
    // });
  
      return found;
    } catch (error) {
      console.error('Error fetching JSON file:', error);
      return false;
    }
  };
  
  export const GetBackBalance = async (processID: string ): Promise<string> => { 
    console.log("processID: " +processID);
    
    try {
        
        const getResult = await message({
            process: processID,
            tags: [
                { name: 'Action', value: 'Balance' },
            ],
            signer: createDataItemSigner(window.arweaveWallet),
        });
        const { Messages, Error } = await result({
            message: getResult,
            process: processID,
        });
        if (Error) {
            console.log("Error:" + Error);
            return "Error:" + Error;
        }
        if (!Messages || Messages.length === 0) {
            console.log("No messages were returned from ao. Please try later.");
            return "No messages were returned from ao. Please try later."; 
        }
        
        console.log('Success: ' + Messages[0].Data);
        return Messages[0].Data;
    } catch (error) {
        console.log('There was an error adding project: ' + error);
        return "Error";
    }
   

};
  